import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import HomePage from "@/pages/home/page";
import LoginPage from "@/pages/login/page";
import ForgotPasswordPage from "@/pages/login/ForgotPassword";
import ResetPasswordPage from "@/pages/login/ResetPassword";
import DashboardPage from "@/pages/dashboard/page";
import RegistroPage from "@/pages/registro/page";
import ValidarCertificadoPage from "@/pages/validar-certificado/page";
import LegalPage from "@/pages/legal/page";
import EstudiantesPage from "@/pages/estudiantes/page";
import EstudianteDetailPage from "@/pages/estudiantes/EstudianteDetailPage";
import CursosPage from "@/pages/cursos/page";
import CursoDetailPage from "@/pages/cursos/CursoDetailPage";
import CursoPublicPage from "@/pages/home/CursoPublicPage";
import DiplomadosPage from "@/pages/diplomados/page";
import DiplomadoDetailPage from "@/pages/diplomados/DiplomadoDetailPage";
import DiplomadoPublicPage from "@/pages/home/DiplomadoPublicPage";
import NoticiaPublicPage from "@/pages/home/NoticiaPublicPage";
import PagosPage from "@/pages/pagos/page";
import InstructorPortalPage from "@/pages/instructor/page";
import InstructorCursoPage from "@/pages/instructor/InstructorCursoPage";
import EvaluadorPortalPage from "@/pages/evaluador/page";
import EvaluadorCursoPage from "@/pages/evaluador/EvaluadorCursoPage";
import CertificadosPage from "@/pages/certificados/page";
import MarketingPage from "@/pages/marketing/page";
import Layout from "@/components/feature/Layout";
import EstudiantePortalPage from "@/pages/estudiante-portal/page";
import ContactosPage from "@/pages/contactos/page";
import UsuariosPage from "@/pages/usuarios/page";
import AuditoriaPage from "@/pages/auditoria/page";
import PerfilPage from "@/pages/perfil/page";
import ConfiguracionPage from "@/pages/configuracion/page";
import NoticiasPage from "@/pages/noticias/page";
import RoleGuard from "@/components/feature/RoleGuard";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/curso/:id", element: <CursoPublicPage /> },
  { path: "/diplomado/:id", element: <DiplomadoPublicPage /> },
  { path: "/noticia/:id", element: <NoticiaPublicPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  { path: "/registro", element: <RegistroPage /> },
  { path: "/validar-certificado", element: <ValidarCertificadoPage /> },
  { path: "/legal", element: <LegalPage /> },
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "dashboard", element: <RoleGuard roles={["super_admin", "admin"]}><DashboardPage /></RoleGuard> },
      { path: "estudiantes", element: <RoleGuard roles={["super_admin", "admin"]}><EstudiantesPage /></RoleGuard> },
      { path: "estudiantes/:id", element: <RoleGuard roles={["super_admin", "admin"]}><EstudianteDetailPage /></RoleGuard> },
      { path: "cursos", element: <RoleGuard roles={["super_admin", "admin"]}><CursosPage /></RoleGuard> },
      { path: "cursos/:id", element: <RoleGuard roles={["super_admin", "admin"]}><CursoDetailPage /></RoleGuard> },
      { path: "diplomados", element: <RoleGuard roles={["super_admin", "admin"]}><DiplomadosPage /></RoleGuard> },
      { path: "diplomados/:id", element: <RoleGuard roles={["super_admin", "admin"]}><DiplomadoDetailPage /></RoleGuard> },
      { path: "pagos", element: <RoleGuard roles={["super_admin", "admin"]}><PagosPage /></RoleGuard> },
      { path: "portal-instructor", element: <RoleGuard roles={["super_admin", "admin", "instructor"]}><InstructorPortalPage /></RoleGuard> },
      { path: "portal-instructor/curso/:id", element: <RoleGuard roles={["super_admin", "admin", "instructor"]}><InstructorCursoPage /></RoleGuard> },
      { path: "portal-evaluador", element: <RoleGuard roles={["super_admin", "admin", "evaluador"]}><EvaluadorPortalPage /></RoleGuard> },
      { path: "portal-evaluador/curso/:id", element: <RoleGuard roles={["super_admin", "admin", "evaluador"]}><EvaluadorCursoPage /></RoleGuard> },
      { path: "certificados", element: <RoleGuard roles={["super_admin", "admin"]}><CertificadosPage /></RoleGuard> },
      { path: "marketing", element: <RoleGuard roles={["super_admin", "admin", "marketing"]}><MarketingPage /></RoleGuard> },
      { path: "noticias", element: <RoleGuard roles={["super_admin", "admin", "marketing"]}><NoticiasPage /></RoleGuard> },
      { path: "contactos", element: <RoleGuard roles={["super_admin", "admin", "marketing"]}><ContactosPage /></RoleGuard> },
      { path: "usuarios", element: <RoleGuard roles={["super_admin"]}><UsuariosPage /></RoleGuard> },
      { path: "auditoria", element: <RoleGuard roles={["super_admin", "admin"]}><AuditoriaPage /></RoleGuard> },
      { path: "configuracion", element: <RoleGuard roles={["super_admin", "admin"]}><ConfiguracionPage /></RoleGuard> },
      { path: "perfil", element: <PerfilPage /> },
      { path: "portal-estudiante", element: <RoleGuard roles={["estudiante"]}><EstudiantePortalPage /></RoleGuard> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
];

export default routes;
